import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import { IUsersTableProps } from "./types";
import { AppContext } from "../../../../Contexts/AppContext";
import { IconButton } from "@mui/material";
import { User, UserRole } from "../../../../models/User";
import DeleteUserModal from "../DeleteUserModal/DeleteUserModal";
import EditUserModal from "../EditUserModal/EditUserModal";
import { useBus } from "react-bus";

const StatusTranslations = {
	ACTIVE: "Activo",
	INACTIVE: "Inactivo",
};

const RoleTranslations: Record<string, string> = {
	ADMIN: "Administrador",
	USER: "Usuario",
};

export default function UsersTable(props: IUsersTableProps) {
	const { users = [] } = props;
	const [userToDelete, setUserToDelete] = React.useState<User | null>(null);
	const [userToEdit, setUserToEdit] = React.useState<User | null>(null);
	const bus = useBus();

	const { userContext } = React.useContext(AppContext);

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
				<TableHead>
					<TableRow>
						<TableCell>Nombre</TableCell>
						<TableCell align='center'>Rol</TableCell>

						<TableCell align='right'>Status</TableCell>
						<TableCell align='right'>Fecha de Ingreso</TableCell>
						<TableCell align='center'>Acciones</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{users.map((row) => (
						<TableRow
							key={row.id}
							sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
							<TableCell component='th' scope='row'>
								{userContext?.userId === row.id
									? `Yo (${row.email})`
									: row.email}
							</TableCell>
							<TableCell align='center'>{RoleTranslations[row.role]}</TableCell>

							<TableCell align='right'>
								{StatusTranslations[row.status]}
							</TableCell>
							<TableCell align='right'>
								{moment(row.updatedAt).format("MM/DD/YYYY hh:mm:ss A")}
							</TableCell>
							<TableCell align='center'>
								{userContext?.role === UserRole.ADMIN ? (
									<>
										<IconButton
											color='primary'
											aria-label='editar usuario'
											onClick={() => {
												setUserToEdit(row);
												bus.emit("openEditUserModal");
											}}>
											<EditIcon />
										</IconButton>
										{userContext?.userId !== row.id ? (
											<IconButton
												color='error'
												aria-label='eliminar usuario'
												onClick={() => {
													setUserToDelete(row);
													bus.emit("openDeleteUserModal");
												}}>
												<DeleteForeverIcon />
											</IconButton>
										) : null}
									</>
								) : null}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
			<DeleteUserModal userToDelete={userToDelete} />
			<EditUserModal userToEdit={userToEdit} />
		</TableContainer>
	);
}
